import * as React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {Button, Col, Form, InputGroup, Row} from "react-bootstrap";
import Loader from "../components/Loader";
import Message from "../components/Message";
import Select from "react-select";

const ResourcesScreen = ({history, language, t}) => {
    const dispatch = useDispatch();
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;

    useEffect(() => {
        if (!userInfo) {
            history.push('/login');
        }
    }, [history, userInfo]);

    return (
        <div>
            <h1 className={'text-center'}>{t('resources_title')}</h1>
            <div>
                <h2 className={'mt-4'}>{t('resource_player_creation')} </h2>
                {
                    userInfo !== undefined && userInfo._id !== undefined ? (<video style={{width: 100 + '%'}} src={`https://smadify.api.bravo-gw.sigmanet.cloud/api/stream/${(userInfo !== null && userInfo._id !== null) ? userInfo._id : ''}/videos/player.mp4`} controls autoPlay={false} type={'video/mp4'}>
                        Your browser does not support the video tag.
                    </video>) : (<div></div>)
                }

{/*                <video style={{width: 100 + '%'}} src={`http://localhost:5000/api/stream/${userInfo._id}/video/player.mp4`} controls autoPlay={false} type={'video/mp4'}>
                    Your browser does not support the video tag.
                </video>*/}
            </div>
            <div>
                <h2 className={'mt-4'}>{t('resource_media_creation')} </h2>
                {
                    userInfo !== undefined && userInfo._id !== undefined ? (<video style={{width: 100 + '%'}} src={`https://smadify.api.bravo-gw.sigmanet.cloud/api/stream/${(userInfo !== null && userInfo._id !== null) ? userInfo._id : ''}/videos/media.mp4`} controls autoPlay={false} type={'video/mp4'}>
                        Your browser does not support the video tag.
                    </video>) : (<div></div>)}

            </div>
            <div>
                <h2 className={'mt-4'}>{t('resource_campaign_creation')} </h2>
                {
                    userInfo !== undefined && userInfo._id !== undefined ? (<video style={{width: 100 + '%'}} src={`https://smadify.api.bravo-gw.sigmanet.cloud/api/stream/${(userInfo !== null && userInfo._id !== null) ? userInfo._id : ''}/videos/campaign.mp4`} controls autoPlay={false} type={'video/mp4'}>
                        Your browser does not support the video tag.
                    </video>) : (<div></div>)}

            </div>


        </div>
    );
};

export default ResourcesScreen;
